import { makeStyles, fade } from '@material-ui/core/styles';
import { screenDims } from '../../styles';

const mobileWidth = '100%';
const dims = screenDims();
const formWidth = 500;

export const dropStyles = makeStyles((theme) => ({
  container: {},
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',

    '& .realmTitle': {
      fontSize: 13,
      '& svg': {
        marginRight: 6,
        marginTop: -2,
      },

      '& .spacer': {
        margin: `0 ${theme.spacing(1)}px`,
      },
    },
    '&.selectTitleRow': {
      textAlign: 'center',
      padding: theme.spacing(3),
      paddingTop: 0,
      width: 300,
      alignSelf: 'center',
      margin: '0 auto',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'row',

      '& svg': {
        margin: '-4px 5px',
      },
    },
  },
  greenText: {
    fontSize: 14,
    color: theme.palette.success.main,
    fontWeight: 'bold',
  },
  title: {
    fontSize: 12,
  },
  firstItem: {
    padding: '6px 0 7px',
  },
  toggleButton: {
    color: theme.palette.secondary.main,
    marginLeft: theme.spacing(2),
  },
  marginLeft: {
    marginLeft: theme.spacing(3),
  },
  realmText: {
    marginLeft: theme.spacing(1),
  },

  realmRowIcon: {
    padding: theme.spacing(1),
  },

  listWrap: {
    width: (props) => (props.isMobile ? mobileWidth : formWidth),
    margin: `0 auto`,
    padding: (props) => (props.isMobile ? 0 : `0 ${theme.spacing(6)}px`),
  },
  listText: {
    fontSize: 13,
    paddingTop: theme.spacing(1),
    paddingBottom: 0,

    '& svg': {
      fontSize: 18,
    },

    '& .realmTitleRow': {
      paddingBottom: theme.spacing(1),
    },

    '& .titleDiv': {
      margin: `${theme.spacing(1)}px 0`,
    },
  },
  list: {
    height: (props) => (props.isMobile ? dims.height - 200 : 'inherit'),
    width: (props) => (props.isMobile ? mobileWidth : formWidth),
    overflowX: 'hidden',
    overflow: 'auto',
    borderTop: `1px solid ${theme.palette.action.disabledBackground}`,
    padding: 0,
    opacity: p => p.loading ? 0.7 : 1,
  },
  listItemRow: {
    width: (props) => (props.isMobile ? mobileWidth : formWidth),
    height: 43,
    cursor: 'pointer',
    padding: 0,
    borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
    pointerEvents: p => p.loading ? 'none' : 'all',

    '&.backIcon': {
      '& > div': {
        marginLeft: 47,
        marginRight: 0,
        backgroundColor: theme.colors.transparent,
      },
      '& .MuiListItemText-root': {
        marginLeft: 0,
      },
    },

    '& .keyText': {
      fontSize: 12,
      alignSelf: 'flex-start',
    },
  },
  listItemRowWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: theme.spacing(3),

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  listRowIcon: {
    backgroundColor: fade(theme.palette.action.disabledBackground, 0.05),
    height: '100%',
    width: 55,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.secondary.main,

    '&:hover': {
      backgroundColor: fade(theme.palette.action.disabledBackground, 0.1),
    },
  },
  listRowIconSelected: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  listRowIconDisabled: {
    '& .MuiIcon-root, .MuiSvgIcon-root': {
      color: theme.palette.action.disabledBackground,
    }
  },
  notSelectable: { 
    pointerEvents: 'none',
    '& .MuiIcon-root, .MuiSvgIcon-root': {
      color: theme.palette.action.disabledBackground,
    }
  },
  listItemRowEdit: {
    height: 'auto',
  },
  isSelected: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  defaultWhite: {
    backgroundColor: theme.colors.transparent,
  },
  secondaryAction: {
    right: 0,
    pointerEvents: 'none',

    '& button': {
      padding: 9,
    },
  },
  secondaryActionIcon: {
    color: theme.palette.text.primary,
  },
  editAction: {
    marginLeft: -17,
    flex: 'none',

    '& button': {
      padding: 9,
    },
  },
  itemEditContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: theme.spacing(1),
  },
  editRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  editButtonRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(1),
    justifyContent: 'flex-end',

    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
  editButton: {
    backgroundColor: theme.colors.blue,
  },
  editCancel: {
    backgroundColor: theme.palette.action.disabled,
  },
  archiveRow: {
    backgroundColor: fade(theme.colors.red, 0.2),
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    alignItems: 'center',
  },
  archiveText: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    fontSize: 12,
  },
  archiveButtonRow: {
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
}));

export default dropStyles;
